import axios from "axios";

interface CEPResult {
    erro?: boolean;
    bairro: string;
    cep: string;
    complemento: string;
    ddd: string;
    gia: string;
    localidade: string;
    logradouro: string;
    siafi: string;
    uf: string;
}

export const getInfosByCep = async (cep: string): Promise<CEPResult> => {
    try {
        let cepFormated = cep.replace(" ", "");

        const result = await axios.get(`https://viacep.com.br/ws/${cepFormated}/json/`);
        const response = await result.data;

        return response;
    } catch(error: any) {
        throw new Error(error.response.data);
    }
}